import { Components } from "@mui/material";

const MuiCard: Components["MuiCard"] = {
  defaultProps: {
    elevation: 0,
  },
};

export { MuiCard };
